import Marquee from 'react-fast-marquee';
import * as Icons from 'lucide-react';
import { FadeUp } from './MaskReveal';
import { INDUSTRIES } from '../../lib/site-data';

function IndustryPill({ name, icon, i }) {
  const Icon = Icons[icon] || Icons.Circle;
  return (
    <div
      data-testid={`industry-pill-${i}`}
      className="group mx-3 inline-flex items-center gap-4 px-6 py-4 border border-white/10 bg-ink-900/70 hover:bg-ink-700 hover:border-signal-500/60 transition-colors duration-500 min-w-max"
    >
      <span className="flex items-center justify-center h-10 w-10 rounded-full border border-white/10 bg-white/[0.02] group-hover:border-signal-500/50 transition-colors duration-500">
        <Icon strokeWidth={1.25} className="h-5 w-5 text-white/70 group-hover:text-signal-500 transition-colors duration-500" />
      </span>
      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/40 leading-none">
          Industry
        </p>
        <p className="display-heading text-white text-lg md:text-xl mt-1.5 leading-none">
          {name}
        </p>
      </div>
    </div>
  );
}

export default function Industries() {
  // Split into two rows for opposing marquees
  const rowA = INDUSTRIES.slice(0, 6);
  const rowB = INDUSTRIES.slice(6);

  return (
    <section id="industries" data-testid="industries-section" className="relative bg-ink-800 py-16 md:py-24 overflow-hidden">
      <div className="container-editorial">
        <div className="mb-10 md:mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <FadeUp>
              <span className="eyebrow">04 — Industries We Serve</span>
            </FadeUp>
            <FadeUp delay={0.1}>
              <h2 className="display-heading mt-6 text-white text-4xl sm:text-5xl lg:text-6xl max-w-3xl">
                Industries We Work With.
              </h2>
            </FadeUp>
          </div>
        </div>
      </div>

      {/* Row A — left */}
      <div className="relative py-3">
        <Marquee gradient={false} speed={38} pauseOnHover direction="left">
          {rowA.map((ind, i) => (
            <IndustryPill key={ind.name} name={ind.name} icon={ind.icon} i={i} />
          ))}
        </Marquee>
        {/* Edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-ink-800 to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-ink-800 to-transparent" />
      </div>

      {/* Row B — right */}
      <div className="relative py-3">
        <Marquee gradient={false} speed={32} pauseOnHover direction="right">
          {rowB.map((ind, i) => (
            <IndustryPill key={ind.name} name={ind.name} icon={ind.icon} i={i + rowA.length} />
          ))}
        </Marquee>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-ink-800 to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-ink-800 to-transparent" />
      </div>
    </section>
  );
}